import type { DistortionProcessor } from "./DistortionProcessor";
import type { ImageAdapter } from "../image-adapter";
import type { ColorResampler } from "../color-resampler";

/**
 * Proxy for performing image colors super-sampling.
 */
export class SuperSamplingProxy implements DistortionProcessor {
  /**
   * SuperSamplingProxy constructor.
   *
   * @param processor
   * @param superSamplingFactor
   */
  constructor(
    private readonly processor: DistortionProcessor,
    private readonly superSamplingFactor: number
  ) {}

  /**
   * Sets resampler's scaling before distortion processing and scales processed image after distortion is processed.
   *
   * @param targetImage
   * @param resampler
   */
  async process<ResourceType>(
    targetImage: ImageAdapter<ResourceType>,
    resampler: ColorResampler
  ): Promise<ImageAdapter<ResourceType>> {
    if (this.superSamplingFactor !== 1) {
      resampler.setScaling(1 / this.superSamplingFactor);
    }
    const result = await this.processor.process(targetImage, resampler);
    if (this.superSamplingFactor !== 1) {
      return result.scale(1 / this.superSamplingFactor);
    }
    return result;
  }
}
